import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http'
import { withClientState } from 'apollo-link-state'
import { onError } from 'apollo-link-error'
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import gql from 'graphql-tag'

import introspectionQueryResultData from 'fragmentTypes.json'

export default (ssr = false, fetch = window.fetch) => {
  // Configure fragment matcher
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData
  });

  // Setup cache
  const cache = new InMemoryCache({ fragmentMatcher })

  // Setup remote link
  const httpLink = createHttpLink({
    uri: ssr ? 'http://proxy/graphql' : `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_HOST_NAME}/graphql`,
    fetch
  });

  // Setup local state
  const defaultState = {
    navigation: {
      __typename: 'Navigation',
      open: false
    }
  }

  const stateLink = withClientState({
    cache,
    defaults: defaultState,
    resolvers: {
      Mutation: {
        // this function could be more simple as it doesn't really need the previous state to determine the new state. However it ilustrates the concept.
        setNavigationOpen: (_, { open }, { cache }) => {
          const query = gql`
            query GetNavigationOpen {
              navigation @client {
                __typename
                open
              }
            }
          `
          const previousState = cache.readQuery({ query })

          const data = {
            ...previousState,
            navigation: {
              ...previousState.navigation,
              open
            }
          }

          cache.writeData({ query, data })

          return null
        }
      }
    }
  })

  // Setup error link
  const errorLink = onError(({ graphQLErrors, networkError, response }) => {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) => {
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
        )

        // Ignore graphql errors so we can let the ui handle 404s
        response.errors = null

        return null;
      });
    if (networkError) console.log(`[Network error]: ${networkError}`);
  })

  // Put it all together
  return new ApolloClient({
    link: ApolloLink.from([
      stateLink,
      errorLink,
      httpLink
    ]),
    cache: ssr ? cache : cache.restore(window.__APOLLO_STATE__),
    ssrMode: ssr
  });
}




// WEBPACK FOOTER //
// ./src/client.js